export default "__VITE_ASSET__D43eo42b__"